import React from "react";

const SettingsPage = () => {
  return (
    <main className="min-h-[calc(100svh-6.82rem)] bg-muted/40">
      <div className="container mx-auto px-6 py-8 bg-gray-100">
        {/* Header */}
        <h1 className="text-3xl font-semibold mb-6">Settings</h1>

        {/* Two-column layout */}
        <div className="flex flex-col md:flex-row gap-6">
          {/* Left Navigation */}
          <aside className="w-full md:w-[180px]">
            <nav className="flex flex-wrap gap-4 text-sm text-muted-foreground md:flex-col">
              <a className="font-semibold text-primary" aria-current="page" href="/general">
                General
              </a>
              <a className="hover:text-primary" href="#">
                Security
              </a>
              <a className="hover:text-primary" href="#">
                Plan & Billing
              </a>
              <a className="hover:text-primary" href="#">
                Notifications
              </a>
            </nav>
          </aside>

          {/* Right Content */}
          <section className="flex-1">
            {/* Profile Card */}
            <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
              <div className="flex flex-col space-y-1.5 p-6">
                <h2 className="text-2xl font-semibold">Profile Information</h2>
                <p className="text-sm text-muted-foreground">
                  Update your public profile details.
                </p>
              </div>

              <div className="p-6 pt-0">
                <div className="flex items-center gap-4 mb-6">
                  <div className="flex flex-col gap-2">
                    <button className="text-left text-primary hover:text-primary/80">
                      Upload Photo
                    </button>
                    <button className="text-left text-destructive hover:text-destructive/80">
                      Remove Photo
                    </button>
                  </div>
                </div>

                {/* Personal Information Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Column 1 */}
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        First Name
                      </label>
                      <p className="mt-1">John</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Username
                      </label>
                      <p className="mt-1">john.doe</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Phone Number
                      </label>
                      <p className="mt-1">+1 555 867 5309</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Country
                      </label>
                      <p className="mt-1">United States</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Zip Code
                      </label>
                      <p className="mt-1">90210</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Time Zone
                      </label>
                      <p className="mt-1">GMT+0800</p>
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Last Name
                      </label>
                      <p className="mt-1">Doe</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Email
                      </label>
                      <p className="mt-1">john.doe@example.com</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        State
                      </label>
                      <p className="mt-1">California</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Address
                      </label>
                      <p className="mt-1">123 Main Street, Apt 48</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Preferred Language
                      </label>
                      <p className="mt-1">English</p>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-muted-foreground">
                        Currency
                      </label>
                      <p className="mt-1">USD</p>
                    </div>
                  </div>
                </div>

                {/* Organization */}
                <div className="mt-6">
                  <label className="block text-sm font-medium text-muted-foreground">
                    Organization (Optional)
                  </label>
                  <p className="mt-1">Tech Innovations Inc.</p>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end gap-4 mt-8">
                  <button className="px-4 py-2 border rounded-md hover:bg-accent hover:text-accent-foreground">
                    Reset
                  </button>
                  <button className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default SettingsPage;
